import React from "react";

import Header from "../../general/Header";
import Aside from "../../general/Aside";
import Footer from "../../general/Footer";
import axios from '../../../axios/axiosconf';
import { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { Link, useLocation } from "react-router-dom";
import Loading from "../../general/Loading";

function EditarAseguradora() {

    const search = useLocation().search;
    const id = new URLSearchParams(search).get('id');

    const [loading, setLoading] = useState(false);
    const [loggedIn, setLoggedIn] = useState(false);
    const [client, setClient] = useState([]);

    const [nombre, setNombre] = useState('');
    const [codigoEmpresa, setCodigoEmpresa] = useState('');
    const [errorlist, setErrorlist] = useState({});

    let history = useHistory();

    let userdata = [];

    useEffect(() => {

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            }
        }


        axios.get('/get-client?uid=' + userdata.user_id, config)
            .then(response => {
                if (response.status === 200) {

                    setClient(response.data);
                    setLoggedIn(true);
                }
            })
            .catch(error => {
                console.log('err: ' + error);
            });

        const config2 = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            },
            params: {
                uid: userdata.user_id,
                id: id
            }
        }

        axios.get('/aseguradora', config2)
            .then(response => {
                setNombre(response.data[0].nombre);
                setCodigoEmpresa(response.data[0].codigo_empresa);
            })
            .catch(error => {
                console.log(error);
            });
    }, []);


    const handleSubmit = (e) => {
        e.preventDefault();
        setLoading(true);

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const data = {
            uid: userdata.user_id,
            id: id,
            nombre: nombre,
            codigo_empresa: codigoEmpresa
        };

        const config = {
            headers: { Authorization: 'Bearer ' + userdata.access_token, Accept: 'application/json' }
        };

        console.log(data);

        axios.put('/aseguradora', data, config)
            .then(
                response => {
                    setLoading(false);
                    localStorage.setItem('toastmsg', 'La EPS "' + nombre + '" Ha Sido Modificada');
                    history.push('/aseguradoras');
                }
            )
            .catch(
                err => {
                    setErrorlist(err.response.data.errors);
                    setLoading(false);
                }
            )
    }


    if (loggedIn) {
        return (

            <div className="hold-transition">
                <Header client={client} />
                <Aside client={client} activelink="settings" />

                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item" key="bc1"><Link to="/home">Home</Link></li>
                                        <li className="breadcrumb-item" key="bc2"><Link to="/settings">Configuración</Link></li>
                                        <li className="breadcrumb-item" key="bc3"><Link to="/parametros-sistema">Parámetros del Sistema</Link></li>
                                        <li className="breadcrumb-item" key="bc4"><Link to="/aseguradoras">EPS / Aseguradoras</Link></li>
                                        <li className="breadcrumb-item" key="bc5">Editar EPS / Aseguradora</li>
                                    </ol>
                                </div>
                            </div>
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <h1 className="m-0">Editar EPS / Aseguradora</h1>
                                </div>
                            </div>
                        </div>
                    </div>
                    <section className="content" >
                        <div className="container-fluid">

                            <div className="row">
                                <div className="col-md-12">

                                    <div className="card">
                                        <div id="infobasica">
                                            <div className="card-body">

                                                <form id="role-form" onSubmit={handleSubmit}>
                                                    <div className="row">
                                                        <div className="col-md-6">
                                                            <div className="form-group">
                                                                <label htmlFor="nombre">Nombre</label>
                                                                <input type="text" name="nombre" className="form-control" id="nombre" value={nombre} onChange={(e) => setNombre(e.target.value)} required disabled={loading} />
                                                                {errorlist.nombre && (
                                                                    <div className="invalid-feedback visible">
                                                                        {errorlist.nombre}
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="form-group">
                                                                <label htmlFor="codigo_empresa">Código</label>
                                                                <input type="text" name="codigo_empresa" className="form-control" id="codigo_empresa" value={codigoEmpresa} onChange={(e) => setCodigoEmpresa(e.target.value)} disabled={loading} />
                                                                {errorlist.codigo_empresa && (
                                                                    <div className="invalid-feedback visible">
                                                                        {errorlist.codigo_empresa}
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row mt-4">
                                                        <div className="col-md-12 d-flex align-items-center">
                                                            <button
                                                                type="button"
                                                                className="btn btn-secondary mr-3 d-inline-flex align-items-center justify-content-center shadow-sm"
                                                                onClick={() => history.push('/aseguradoras')}
                                                                style={{ padding: '8px 20px' }}
                                                            >
                                                                <i className="fas fa-times mr-2"></i> Cancelar
                                                            </button>
                                                            <button
                                                                type="submit"
                                                                className="btn btn-primary d-inline-flex align-items-center justify-content-center shadow-sm"
                                                                disabled={loading}
                                                                style={{ padding: '8px 20px' }}
                                                            >
                                                                <i className="fas fa-save mr-2"></i> Guardar Cambios
                                                                {loading && <span className="spinner-border spinner-border-sm ml-2" role="status" aria-hidden="true"></span>}
                                                            </button>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>

                        </div>
                    </section>
                </div>
                <Footer showToast={false} />
            </div>

        );
    }

    return (
        <Loading />
    );
}
export default EditarAseguradora;